// import "./tableElectric.css"
import React, { useContext, useEffect, useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil} from '@fortawesome/free-solid-svg-icons'


const TableElectric = ({ data= [], handleEdit }) => {
    // console.log('data', data)
    return (
        <div className="overflow-x-auto">
            <table className="min-w-full border-collapse border border-gray-300">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="border border-gray-300 px-4 py-2">ユーティリティID</th>
                        <th className="border border-gray-300 px-4 py-2">名称</th>
                        <th className="border border-gray-300 px-4 py-2">電気種</th>
                        <th className="border border-gray-300 px-4 py-2">電力 (A)</th>
                        <th className="border border-gray-300 px-4 py-2">電力 (KVA)</th>
                        {/* <th className="border border-gray-300 px-4 py-2">ブレーカサイズ</th> */}
                        <th className="border border-gray-300 px-4 py-2">備考</th>
                        <th className="border border-gray-300 px-4 py-2">最終更新者</th>
                        <th className="border border-gray-300 px-4 py-2"></th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map((row, index) => (
                            <tr key={index} className="hover:bg-gray-100">
                                <td className="border border-gray-300 px-4 py-2">{row.uttID}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.electricName}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.electricType}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.capacityA}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.capacityKVA}</td>
                                {/* <td className="border border-gray-300 px-4 py-2">{row.electricSize}</td> */}
                                <td className="border border-gray-300 px-4 py-2">{row.remark1}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.updatedBy}</td>
                                <td>
                                    <button onClick={() => handleEdit(row, 'electric')}>
                                        <FontAwesomeIcon icon={faPencil} />
                                        {/* 編集 */}

                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center border border-gray-300 px-4 py-2">
                                データがありません
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default TableElectric;
